




















import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FeaturesList from '@/componentsV2/molecules/FeaturesList/FeaturesList.vue';

@Component({
  components: {
    Typography,
    FeaturesList
  }
})
export default class Campaigns extends Vue {
  @Prop() campaigns!: any;

  get tPrefix() {
    return 'modals.billing.reactivation.campaigns';
  }
}
